import { Route, Routes } from 'react-router-dom';
import LoggedIn from './LoggedIn';
import NoAccount from './NoAccount';
import Profile from './Profile';

const ProfileRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Profile />}>
        <Route path="no-account" element={<NoAccount />} />
        <Route path="account" element={<LoggedIn />} />
      </Route>
    </Routes>
  );
};

export default ProfileRoutes;
